<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_1_11)">
      <rect
        width="24"
        height="24"
        fill="#212431"
      />
      <circle
        cx="12"
        cy="25"
        r="8"
        fill="url(#paint0_linear_1_11)"
        fill-opacity="0.32"
      />
      <circle
        cx="12"
        cy="10"
        r="4"
        fill="url(#paint1_linear_1_11)"
        fill-opacity="0.32"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_11"
        x1="12"
        y1="17"
        x2="12"
        y2="33"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop
          offset="1"
          stop-color="white"
          stop-opacity="0.44"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_11"
        x1="12"
        y1="6"
        x2="12"
        y2="14"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop
          offset="1"
          stop-color="white"
          stop-opacity="0.44"
        />
      </linearGradient>
      <clipPath id="clip0_1_11">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs></svg>
</template>

<script>
export default {
  name: 'FilledSeatIcon',
  props: {
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    }
  }
}
</script>

<style scoped></style>
